<template>
  <v-card flat>
    <v-data-table
        :loading="loading"
        loading-text="Đang Tải"
        :headers="headers"
        :items="contacts"
        :search="search"
        v-model="selected"
        show-select
        @click:row="onContactSelected"
    >
      <v-layout slot="top">
        <v-flex xs12 sm8 md8 class="pa-6">
          <contact-filter @onFilterChanged="refresh"></contact-filter>
          <contact-action :selected="selected"></contact-action>
        </v-flex>
        <v-flex xs12 sm4 md4 class="pa-6">
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Tìm kiếm nhanh"
              clearable
              dense
              outlined
          />
        </v-flex>
      </v-layout>
      <template v-slot:item.meetingDate="{ item }">
        {{item.meetingDate | familiarizeDate}}
      </template>
      <template v-slot:item.handledDate="{ item }">
        {{item.handledDate | SimplizedDate}}
      </template>
      <template v-slot:item.onboard="{ item }">
        {{item.onboard | familiarizeDate}}
      </template>
    </v-data-table>
    <contact-drawer :draw="draw" @onDrawerStateChange="updateDraw"></contact-drawer>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import ContactDrawer from '@/modules/contact/ContactDrawer'
import ContactFilter from '@/modules/contact/ContactFilter'
import ContactAction from '@/modules/contact/ContactAction'

export default {
  components: {
    ContactDrawer,
    ContactAction,
    ContactFilter
  },
  data () {
    return {
      search: '',
      loading: true,
      headers: [
        { text: 'Tên Phụ Huynh', value: 'parentName' },
        { text: 'Tên Học Sinh', value: 'name' },
        { text: 'Điện Thoại Phụ Huynh', value: 'parentPhone' },
        { text: 'Email Phụ Huynh  ', value: 'parentEmail' },
        { text: 'Level Sale', value: 'level' },
        { text: 'Ngày xử lý ', value: 'handledDate' },
        { text: 'Ngày Onboard ', value: 'onboard' },
        { text: 'Ngày Trải Nghiệm', value: 'meetingDate' },
        { text: 'Nguồn ', value: 'provider' },
        { text: 'PIC ', value: 'staff.code' }
      ],
      selected: [],
      draw: false
    }
  },
  computed: {
    ...mapGetters('contact', ['contacts']),
    ...mapGetters('app', ['department'])
  },
  methods: {
    ...mapActions('contact', ['fetchContacts', 'setCurrentContact', 'clearContacts']),
    onContactSelected (contact) {
      this.setCurrentContact(contact)
      this.draw = true
    },
    updateDraw (state) {
      this.draw = state
    },
    async refresh (query) {
      this.clearContacts()
      this.loading = true
      await this.fetchContacts('?department=' + this.department.id + '&' + query)
      this.loading = false
    }
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('Ngày DD/MM')
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM')
    }
  },
  watch: {
    department: {
      handler (d) {
        this.clearContacts()
        this.fetchContacts('?department=' + this.department.id)
      }
    }
  }
}
</script>
<style>
  .v-select__level-sale {
    font-size: 1em;
    border: none
  }
</style>
